export default {
    SET_IS_LOADING: 'SET_IS_LOADING'
};
